import dayjs from "dayjs";
import { ReportVisitQuestionEvent } from "../../api/Event";
import { Exam } from "../../model/exam/Exam";
import { Question } from "../../model/question/Question";
import { RateEvent, RateEventType } from "../../model/Rate";
import { LogTrace } from "../../tools/log";
import { selectExam } from "../exam/selector";
import { AppThunk } from "../hooks";
import { selectEventScene, selectQuestion } from "../question/selector";
import { RootState } from "../ReduxStore";
import { selectPageSource } from "../root/selector";

export const actionRecordEvent = (
    type: RateEventType,
    questionOrNull?: Question,
    examOrNull?: Exam
): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        const question = questionOrNull ? questionOrNull : selectQuestion(state);
        const action = question.action;
        const questionID = question.data.id;
        if (questionID.length === 0) {
            return;
        }
        const scene = selectEventScene(state);
        const exam = examOrNull ? examOrNull : selectExam(state);
        const pageSource = selectPageSource(state);
        const event = {
            type: type,
            user_id: state.user.data.id,
            question_id: questionID,
            time_stamp: dayjs().unix(),
            scene,
            source: pageSource,
            exam_id: exam.id,
            exam_name: exam.name,
            cost_seconds: action.used_time_seconds,
            question_type: question.data.kind,
            exam_type: exam.kind,
        } as RateEvent;

        ReportVisitQuestionEvent({
            userID: state.user.data.id,
            event: event,
            afterSuccess: () => {
                LogTrace("report event", event);
            },
            dispatch,
        });
    };
};
